import variables from 'variables.module.scss';

export const DatePicker = {
  cellHoverBg: variables.whiteColor,
  activeShadow: 'none',
};
